import React, { useState, useEffect } from "react";
import { createCategory, updateCategory } from "./adminOfficialSentenceService";
import "../../styles/content.css";

const CATEGORY_KEYS = [
  // Professional Essentials (1–16)
  "MEETINGS", "PRESENTATIONS", "EMAIL_COMMUNICATION", "JOB_INTERVIEWS",
  "CUSTOMER_SERVICE", "NEGOTIATIONS", "NETWORKING", "PHONE_CALLS",
  "PERFORMANCE_REVIEWS", "PROJECT_MANAGEMENT", "SALES_PITCHES", "TRAINING_SESSIONS",
  "CONFLICT_RESOLUTION", "LEADERSHIP", "TEAM_COLLABORATION", "CLIENT_RELATIONS",

  // Business Core (17–26)
  "INTERVIEWS", "EMAILS", "REPORTS", "PROPOSALS",
  "CONFERENCES", "OFFICE_TALK", "FEEDBACK", "ONBOARDING",
  "RESIGNATIONS", "PROMOTIONS",

  // Industry & Sector (27–34)
  "LEGAL", "FINANCE", "BANKING", "INSURANCE",
  "REAL_ESTATE", "CONSULTING", "MARKETING", "SALES",

  // Government & Public (35–42)
  "GOVERNMENT", "IMMIGRATION", "COURT", "POLICE",
  "TAX", "CUSTOMS", "EMBASSY", "PUBLIC_SERVICES",

  // Medical & Academic (43–49)
  "MEDICAL", "HOSPITAL_ADMIN", "ACADEMIC", "RESEARCH",
  "TEACHING", "EXAMINATIONS", "ADMISSIONS",

  // Formal Communication (50–57)
  "FORMAL_GREETINGS", "FORMAL_INVITATIONS", "FORMAL_COMPLAINTS",
  "FORMAL_APOLOGIES", "FORMAL_REQUESTS", "FORMAL_ANNOUNCEMENTS",
  "CEREMONIES", "DIPLOMACY",

  // Tech & IT (58–61)
  "IT_SUPPORT", "SOFTWARE_DEVELOPMENT", "CLIENT_CALLS", "TECHNICAL_WRITING",
];

const OfficialSentenceCategoryForm = ({ category, onSaved, onCancel }) => {
  const isEdit = !!category;
  const [form, setForm] = useState({
    category: "", title: "", description: "", icon: "",
    youtubeVideoUrl: "", videoTitle: "", videoDescription: "",
    sortOrder: 1, isActive: true,
  });
  const [useCustomKey, setUseCustomKey] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (category) {
      console.log("[OfficialSentenceCategoryForm] Populating for edit, id:", category.id, "key:", category.category);
      const key = category.category || "";
      setForm({
        category: key, title: category.title || "", description: category.description || "",
        icon: category.icon || "", youtubeVideoUrl: category.youtubeVideoUrl || "",
        videoTitle: category.videoTitle || "", videoDescription: category.videoDescription || "",
        sortOrder: category.sortOrder || 1, isActive: category.isActive !== false,
      });
      if (key && !CATEGORY_KEYS.includes(key)) {
        console.log("[OfficialSentenceCategoryForm] Key not in predefined list, switching to custom input");
        setUseCustomKey(true);
      }
    }
  }, [category]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    console.log("[OfficialSentenceCategoryForm] Field changed:", name, "=>", type === "checkbox" ? checked : value);
    setForm({ ...form, [name]: type === "checkbox" ? checked : value });
  };

  const handleSubmit = async () => {
    if (!form.category || !form.title) {
      console.warn("[OfficialSentenceCategoryForm] Validation failed");
      alert("Category key and Title are required");
      return;
    }
    const payload = { ...form, sortOrder: Number(form.sortOrder) || 1 };
    console.log("[OfficialSentenceCategoryForm] Submitting", isEdit ? "update" : "create", "payload:", payload);
    setLoading(true);
    const res = isEdit ? await updateCategory(category.id, payload) : await createCategory(payload);
    if (res.status === 200 || res.status === 201) {
      console.log("[OfficialSentenceCategoryForm] Submit successful:", res.status);
      onSaved();
    } else {
      console.error("[OfficialSentenceCategoryForm] Submit failed:", res.status, res.message);
      alert(res.message || "Operation failed");
    }
    setLoading(false);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ width: 560, maxHeight: "90vh", overflowY: "auto" }}>
        <div className="form-card" style={{ margin: 0, boxShadow: "none" }}>
          <h2>{isEdit ? "Edit" : "Create"} Category</h2>
          <div className="form-group">
            <label>Category Key *</label>
            {isEdit ? (<input value={form.category} disabled />) : useCustomKey ? (
              <>
                <input name="category" placeholder="e.g. MY_CUSTOM_KEY" value={form.category}
                  onChange={(e) => { const val = e.target.value.toUpperCase().replace(/[^A-Z0-9_]/g, ""); setForm({ ...form, category: val }); }} />
                <button type="button" onClick={() => { setUseCustomKey(false); setForm({ ...form, category: "" }); }}
                  style={{ marginTop: 4, fontSize: 12, background: "none", border: "none", color: "#019095", cursor: "pointer" }}>← Pick from list</button>
              </>
            ) : (
              <>
                <select name="category" value={form.category} onChange={handleChange}>
                  <option value="">Select Category Key</option>
                  {CATEGORY_KEYS.map((k) => (<option key={k} value={k}>{k}</option>))}
                </select>
                <button type="button" onClick={() => setUseCustomKey(true)}
                  style={{ marginTop: 4, fontSize: 12, background: "none", border: "none", color: "#019095", cursor: "pointer" }}>+ Enter custom key</button>
              </>
            )}
          </div>
          <div className="form-group"><label>Title *</label><input name="title" placeholder="Meetings & Conferences" value={form.title} onChange={handleChange} /></div>
          <div className="form-group"><label>Description</label><textarea name="description" placeholder="Brief description..." value={form.description} onChange={handleChange} rows={2} /></div>
          <div className="form-group"><label>Icon (emoji)</label><input name="icon" placeholder="👥" value={form.icon} onChange={handleChange} /></div>
          <div className="form-group"><label>YouTube Video URL</label><input name="youtubeVideoUrl" placeholder="https://youtube.com/watch?v=..." value={form.youtubeVideoUrl} onChange={handleChange} /></div>
          <div className="form-group"><label>Video Title</label><input name="videoTitle" placeholder="Master Meeting English" value={form.videoTitle} onChange={handleChange} /></div>
          <div className="form-group"><label>Video Description</label><textarea name="videoDescription" placeholder="Video description..." value={form.videoDescription} onChange={handleChange} rows={2} /></div>
          <div className="form-group"><label>Sort Order</label><input name="sortOrder" type="number" min="1" value={form.sortOrder} onChange={handleChange} /></div>
          <div className="form-group"><label style={{ display: "flex", alignItems: "center", gap: 8 }}><input name="isActive" type="checkbox" checked={form.isActive} onChange={handleChange} /> Active</label></div>
          <div className="form-actions">
            <button onClick={handleSubmit} disabled={loading}>{loading ? "Saving..." : isEdit ? "Update" : "Create"}</button>
            <button onClick={onCancel} disabled={loading}>Cancel</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfficialSentenceCategoryForm;
